import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Property from '@afosto/app-components-react/Property';
import getFullName from '@afosto/utils/getFullName';
import { contacts as contactsApi } from '@afosto/contacts/api/Contacts';
import { organisations as organisationsApi } from '@afosto/contacts/api/Organisations';
import translations from './translations';

const VendorSection = ({ vendor }) => {
  const intl = useIntl();
  const vendorContact = vendor?.contact ?? {};
  const { id: contactId, organisation_id: organisationId } = vendorContact;
  const [contact, setContact] = useState(null);
  const [organisation, setOrganisation] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchContact = async () => {
      try {
        const response = await contactsApi.getContact(contactId);
        const { data } = response;

        if (isMounted) {
          setContact(data);
        }
      } catch (err) {
        if (isMounted) {
          setContact(null);
        }
      }
    };

    if (contactId) {
      fetchContact();
    }

    return () => {
      isMounted = false;
    };
  }, [contactId]);

  useEffect(() => {
    let isMounted = true;

    const fetchOrganisation = async () => {
      try {
        const response = await organisationsApi.viewOrganisation(organisationId);
        const { data } = response;

        if (isMounted) {
          setOrganisation(data);
        }
      } catch (err) {
        if (isMounted) {
          setOrganisation(null);
        }
      }
    };

    if (organisationId) {
      fetchOrganisation();
    }

    return () => {
      isMounted = false;
    };
  }, [organisationId]);

  return (
    <Card>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        <Property
          label={intl.formatMessage(translations.properties.contact)}
          value={contact ? getFullName(contact) : null}
        />

        <Property
          label={intl.formatMessage(translations.properties.email)}
          value={vendorContact?.email}
        />

        <Property
          label={intl.formatMessage(translations.properties.organisation)}
          value={organisation ? organisation.name : null}
        />

        <Property
          label={intl.formatMessage(translations.properties.cocNumber)}
          value={vendorContact?.coc_number}
        />

        <Property
          label={intl.formatMessage(translations.properties.vatNumber)}
          value={vendorContact?.vat_number}
        />

        <Property
          label={intl.formatMessage(translations.properties.vatCountryCode)}
          value={vendor?.vat_country_code}
        />
      </CardContent>
    </Card>
  );
};

VendorSection.propTypes = {
  vendor: PropTypes.object,
};

VendorSection.defaultProps = {
  vendor: undefined,
};

export default VendorSection;
